export default "__VITE_ASSET__DjeKqbe1__"